import React, { Component } from "react";

export default class AvatarFetching extends Component {
  render() {
    return (
      <div className="user-fetching">
        <div className="user-avatar gradiant" />
        <h3 className="gradiant" />
        <h4 className="gradiant" />
        <span />
        <h5 className="gradiant" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/AvatarFetching.js